import axios from 'axios';

class InstanceAxios {
    constructor() {
        this.instance = axios.create({
            baseURL: process.env.REACT_APP_KEYCLOAK_URL_AUTH,
            headers: { 'Content-Type': 'application/json' },
        });
    }

    getInstance() {
        return this.instance;
    }

    setToken(token) {
        this.instance.defaults.headers['Authorization'] = `Bearer ${token}`;
    }
}

const singletonAxios = new InstanceAxios();
export default singletonAxios;
